import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

interface Props {
    src: string;
    alt?: string;
    className?: string;
    testId?: string;
}

const useStyles = makeStyles(() => ({
    logo: {
        maxHeight: "45px",
        marginRight: "1rem",
        marginLeft: "0.5rem"
    },
}));

const MenuLogo: React.FC<Props> = props => {
    const classes = useStyles();
    return (
        <img
            data-cy={props.testId}
            src={props.src}
            className={clsx(classes.logo, props.className)}
            alt={props.alt || "Logo"} />
    );
};

export default MenuLogo;
